<template>
  <h2 class="pb-2 border-bottom">Telemedicina</h2>
  <p>Telemedicina: cuidado acessível onde você estiver</p>
  <p>Na Diverse Care Now, você pode receber atendimento médico em casa, em inglês, português ou espanhol.
  Nossos serviços de telemedicina incluem:</p>
  <ul>
    <li>Cuidados primários gerais — consultas online para doenças comuns (resfriados, gripes, alergias), renovação de receitas, acompanhamento de doenças crônicas (diabetes, hipertensão, tireoide) e orientações preventivas.</li>
    <li>Controle de peso & saúde metabólica — monitoramento virtual, prescrição segura (incluindo terapias supervisionadas por médicos), aconselhamento nutricional e programas supervisionados.</li>
    <li>Saúde da mulher & do homem — acompanhamento de HRT e TRT, menopausa, SOP e equilíbrio hormonal contínuo.</li>
    <li>Saúde mental & suporte ao estilo de vida — consultas online para ansiedade, depressão, coaching de bem-estar e qualidade de vida.</li>
  </ul>
  <p>“Com nossa plataforma segura de telemedicina, você recebe o mesmo cuidado personalizado da clínica — no conforto da sua casa.”</p>
</template>

<script>
export default {
  name: 'TelemedicineContentPtBR'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
